import { Pipe, PipeTransform } from '@angular/core';
import { formatNum } from 'src/app/core/utils/text-utils';

@Pipe({
  name: 'formatNum',
  standalone: false,
})
export class FormatNumPipe implements PipeTransform {
  /**
   * `formatNum` is asked for the text even when there is no symbol to wrap it in. It used to be
   * handed the value straight through in that case, which is the common one — most number fields
   * carry no format — so a small number reached the screen as `1e-10`.
   */
  public transform(num?: string | number | null, format?: string): string {
    return formatNum(num, format);
  }
}
